export enum ROUTES {
  DASHBOARD = '/dashboard',
  ANALYTICS = '/analytics',
  ORDERS = '/orders',
  DISPUTES = '/disputes',
  DISPUTES_ALL = '/all',
  DISPUTES_QUEUES = '/queues',
  DISPUTES_QUEUE = '/queue',
  DISPUTES_QUEUE_ITEM = '/queue-item',
  DISPUTES_ARCHIVED = '/archived',
  FUNDS = '/funds',
  SETTLEMENTS = '/settlements',
  LATEST_SETTLEMENTS = '/latest',
  ALL_SETTLEMENTS = '/all',
  BATCHES = '/payouts',
  POSTED = '/posted',
  UNPOSTED = '/unposted',
  SHELVED = '/shelved',
  FUNDS_RESERVE = '/funds-reserve',
  FINANCE = '/finance',
  USERS = '/users',
  PARTNERS = '/partners',
  CONTACTS = '/contacts',
  AGENCIES = '/agencies',
  AGENCIES_COMMISSIONS = '/commissions',
  AGENCIES_DEALS = '/deals',
  RISK = '/risk',
  BLOCK_LIST = '/block-list',
  RESERVE_CONFIG = '/reserve-config',
  ACCOUNTS = '/accounts',
  APPLICATIONS = '/applications',
  MERCHANTS = '/merchants',
  ADMIN = '/admin',
  PROVIDERS = '/providers',
  PROCESSING = '/processing',
  QUARANTINED = '/quarantined',

}